import { create } from 'zustand';

interface CommonMainLayoutStore {
  isLpNaviMove: boolean;
  setIsLpNaviMove: (isLpNaviMove: boolean) => void;
  getIsLpNaviMove: () => boolean;
}

const useCommonMainLayoutStore = create<CommonMainLayoutStore>((set, get) => ({
  isLpNaviMove: false,
  setIsLpNaviMove: isLpNaviMove => set({ isLpNaviMove }),
  getIsLpNaviMove: () => get().isLpNaviMove,
}));

export default useCommonMainLayoutStore;
